// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IInvestmentOperationRequestDto
 */
export interface IInvestmentOperationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IInvestmentOperationRequestDto
     */
    option?: IInvestmentOperationRequestDtoOptionEnum;
}

/**
* @export
* @enum {string}
*/
export enum IInvestmentOperationRequestDtoOptionEnum {
    MANAGED = 'MANAGED',
    BROKERAGE = 'BROKERAGE',
    SELF_DIRECTED = 'SELF_DIRECTED'
}


/**
 * Check if a given object implements the IInvestmentOperationRequestDto interface.
 */
export function instanceOfIInvestmentOperationRequestDto(value: object): value is IInvestmentOperationRequestDto {
    return true;
}

export function IInvestmentOperationRequestDtoFromJSON(json: any): IInvestmentOperationRequestDto {
    return IInvestmentOperationRequestDtoFromJSONTyped(json, false);
}

export function IInvestmentOperationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvestmentOperationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'option': json['option'] == null ? undefined : json['option'],
    };
}

export function IInvestmentOperationRequestDtoToJSON(json: any): IInvestmentOperationRequestDto {
    return IInvestmentOperationRequestDtoToJSONTyped(json, false);
}

export function IInvestmentOperationRequestDtoToJSONTyped(value?: IInvestmentOperationRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'option': value['option'],
    };
}

